module.exports = __webpack_public_path__ + "static/media/icomoon.24aea5ce.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon.ttf?hujj0d
// module id = ./src/assets/fonts/icomoon.ttf?hujj0d
// module chunks = 23